module.exports = __webpack_public_path__ + "img/az.99438a1c.png";